<!-- App -->
<!-- 导航 + 路由 -->
<template>
  <div id="app">
    <headers/>
    <router-view/>
  </div>
</template>

<script>
// 导航
import headers from './components/Heade'
export default {
  name: 'App',
  components: {
    headers
    // top
  }
}
</script>

<style lang="less">
html,body {
  height: 100%;
  margin: 0 auto;
  background-color: #0d0d0d;
}
a {
  text-decoration:none
}
body {
  overflow-y: auto;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
#app {
  .width1200 {
    width: 1200px;
      margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue